import {
  setZuoraUserAccountSubscriptionCancelConfirmed,
  getUserAccountBillingSubscriptionsWithDetailsZuora,
  getUserAccountGiftSubscriptionsWithDetails,
  changeUserAccountPlanTypeDataZuora,
} from './index'

export const SET_USER_ACCOUNT_SUBSCRIPTION_MANAGE_TYPE = 'SET_USER_ACCOUNT_SUBSCRIPTION_MANAGE_TYPE'
export const SET_USER_ACCOUNT_CANCEL_REASON = 'SET_USER_ACCOUNT_CANCEL_REASON'
export const SET_USER_ACCOUNT_CANCEL_FORM_DATA = 'SET_USER_ACCOUNT_CANCEL_FORM_DATA'
export const RESET_USER_ACCOUNT_CANCEL_FORM_DATA = 'RESET_USER_ACCOUNT_CANCEL_FORM_DATA'
export const RESET_USER_ACCOUNT_MANAGE_SUBSCRIPTION_DATA = 'RESET_USER_ACCOUNT_MANAGE_SUBSCRIPTION_DATA'
export const SET_USER_ACCOUNT_CANCEL_CONFIRM_PROCESSING = 'SET_USER_ACCOUNT_CANCEL_CONFIRM_PROCESSING'
export const SET_USER_ACCOUNT_CANCEL_CONFIRM_DATA = 'SET_USER_ACCOUNT_CANCEL_CONFIRM_DATA'
export const SET_USER_ACCOUNT_CANCEL_CONFIRM_ANSWER = 'SET_USER_ACCOUNT_CANCEL_CONFIRM_ANSWER'
export const SET_USER_ACCOUNT_BILLING_SUBSCRIPTIONS_PROCESSING = 'SET_USER_ACCOUNT_BILLING_SUBSCRIPTIONS_PROCESSING'
export const SET_USER_GIFT_SUBSCRIPTIONS_PROCESSING = 'SET_USER_ACCOUNT_GIFT_PROCESSING'
export const SET_USER_ACCOUNT_DATA_BILLING_SUBSCRIPTIONS = 'SET_USER_ACCOUNT_DATA_BILLING_SUBSCRIPTIONS'
export const SET_USER_ACCOUNT_DATA_BILLING_SUBSCRIPTIONS_WITH_DETAILS = 'SET_USER_ACCOUNT_DATA_BILLING_SUBSCRIPTIONS_WITH_DETAILS'
export const SET_USER_GIFT_SUBSCRIPTIONS_WITH_DETAILS = 'SET_USER_GIFT_SUBSCRIPTIONS_WITH_DETAILS'
export const CHANGE_USER_ACCOUNT_CHANGE_PLAN_TYPE_PROCESSING = 'CHANGE_USER_ACCOUNT_CHANGE_PLAN_TYPE_PROCESSING'
export const CHANGE_USER_ACCOUNT_PLAN_TYPE_SET_DATA = 'CHANGE_USER_ACCOUNT_PLAN_TYPE_SET_DATA'
export const SET_USER_ACCOUNT_PAUSE_PROCESSING = 'SET_USER_ACCOUNT_PAUSE_PROCESSING'
export const SET_USER_ACCOUNT_PAUSE_DATA = 'SET_USER_ACCOUNT_PAUSE_DATA'
export const SET_USER_ACCOUNT_PAUSE_LENGTH = 'SET_USER_ACCOUNT_PAUSE_LENGTH'
export const SET_USER_ACCOUNT_PAUSE_FORM_DATA = 'SET_USER_ACCOUNT_PAUSE_FORM_DATA'
export const CLEAR_USER_ACCOUNT_BILLING_SUBSCRIPTIONS_WITH_DETAILS = 'CLEAR_USER_ACCOUNT_BILLING_SUBSCRIPTIONS_WITH_DETAILS'
export const RESET_ACCOUNT_CHANGE_PLAN_DATA = 'RESET_ACCOUNT_CHANGE_PLAN_DATA'
export const SET_USER_ACCOUNT_SUBSCRIPTION_PAYMENTS_PROCESSING = 'SET_USER_ACCOUNT_SUBSCRIPTION_PAYMENTS_PROCESSING'
export const SET_USER_ACCOUNT_SUBSCRIPTION_PAYMENTS_DATA = 'SET_USER_ACCOUNT_SUBSCRIPTION_PAYMENTS_DATA'
export const UPDATE_USER_ACCOUNT_CANCEL_OFFER_SHOWN = 'UPDATE_USER_ACCOUNT_CANCEL_OFFER_SHOWN'
export const SET_USER_ACCOUNT_CANCEL = 'SET_USER_ACCOUNT_CANCEL'
export const UPDATE_USER_ACCOUNT_PLAN = 'UPDATE_USER_ACCOUNT_PLAN'
export const SET_USER_ACCOUNT_INVOICE_HISTORY_PROCESSING = 'SET_USER_ACCOUNT_INVOICE_HISTORY_PROCESSING'
export const SET_USER_ACCOUNT_INVOICE_HISTORY_DATA = 'SET_USER_ACCOUNT_INVOICE_HISTORY_DATA'
export const SET_USER_ACCOUNT_INVOICE_PROCESSING = 'SET_USER_ACCOUNT_INVOICE_PROCESSING'
export const SET_USER_ACCOUNT_INVOICE_DATA = 'SET_USER_ACCOUNT_INVOICE_DATA'
export const SET_USER_ACCOUNT_TYPE = 'SET_USER_ACCOUNT_TYPE'

// Account Pause V2
export const UPDATE_USER_ACCOUNT_PAUSE = 'UPDATE_USER_ACCOUNT_PAUSE'
export const SET_USER_ACCOUNT_PAUSE = 'SET_USER_ACCOUNT_PAUSE'
export const RESET_USER_ACCOUNT_PAUSE_ERRORS = 'RESET_USER_ACCOUNT_PAUSE_ERRORS'
export const UPDATE_USER_ACCOUNT_RESUME = 'UPDATE_USER_ACCOUNT_RESUME'
export const SET_USER_ACCOUNT_RESUME = 'SET_USER_ACCOUNT_RESUME'

export const UPDATE_USER_BILLING_ADDRESS_ZUORA_PAYPAL = 'UPDATE_USER_BILLING_ADDRESS_ZUORA_PAYPAL'
export const UPDATED_USER_BILLING_ADDRESS_ZUORA_PAYPAL = 'UPDATED_USER_BILLING_ADDRESS_ZUORA_PAYPAL'
export const RESET_USER_BILLING_ADDRESS_ZUORA_PAYPAL_STATE = 'RESET_USER_BILLING_ADDRESS_ZUORA_PAYPAL_STATE'

export function updateBillingAddressZuoraPaypal ({ auth, postalCode, requireZipcodeUpdate2021 }) {
  return {
    type: UPDATE_USER_BILLING_ADDRESS_ZUORA_PAYPAL,
    payload: { auth, postalCode, requireZipcodeUpdate2021 },
  }
}

export function resetBillingAddressZuoraPaypalState () {
  return {
    type: RESET_USER_BILLING_ADDRESS_ZUORA_PAYPAL_STATE,
    payload: {},
  }
}

export function changeUserAccountPlanType (planInfo) {
  return async function changeUserAccountPlanTypeThunk (dispatch) {
    try {
      dispatch(changeUserAccountPlanTypeProcessing(true))
      const data = await changeUserAccountPlanTypeDataZuora(planInfo)
      dispatch(changeUserAccountPlanTypeSetData(data))
    } catch (e) {
      dispatch(changeUserAccountPlanTypeProcessing(false))
    }
  }
}

export function setUserAccountCancelSubscriptionConfirm ({ auth }) {
  return async function setUserAccountCancelSubscriptionConfirmThunk (dispatch) {
    try {
      dispatch(setUserAccountCancelSubscriptionConfirmProcessing(true))
      const data = await setZuoraUserAccountSubscriptionCancelConfirmed({ auth })
      dispatch(setUserAccountCancelSubscriptionConfirmData(data))
    } catch (e) {
      dispatch(setUserAccountCancelSubscriptionConfirmProcessing(false))
    }
  }
}

export function getUserAccountDataBillingSubscriptionsWithDetails ({ auth }) {
  return async function getUserAccountDataBillingSubscriptionsWithDetailsThunk (dispatch) {
    try {
      dispatch(setUserAccountBillingSubscriptionsProcessing(true))
      const data = await getUserAccountBillingSubscriptionsWithDetailsZuora({ auth })
      dispatch(setUserAccountDataBillingSubscriptionsWithDetails(data))
    } catch (e) {
      dispatch(setUserAccountBillingSubscriptionsProcessing(false))
    }
  }
}

export function getUserGiftSubscriptionsWithDetails ({ auth }) {
  return async function getUserGiftSubscriptionsWithDetailsThunk (dispatch) {
    try {
      dispatch(setUserGiftSubscriptionsProcessing(true))
      const data = await getUserAccountGiftSubscriptionsWithDetails({ auth })
      dispatch(setUserGiftSubscriptionsWithDetails(data))
    } catch (e) {
      dispatch(setUserGiftSubscriptionsProcessing(false))
    }
  }
}

export function setUserAccountSubscriptionManageType (value) {
  return {
    type: SET_USER_ACCOUNT_SUBSCRIPTION_MANAGE_TYPE,
    payload: value,
  }
}

export function setUserAccountCancelReason (value) {
  return {
    type: SET_USER_ACCOUNT_CANCEL_REASON,
    payload: value,
  }
}

export function setUserAccountCancelFormData (data) {
  return {
    type: SET_USER_ACCOUNT_CANCEL_FORM_DATA,
    payload: data,
  }
}

export function resetUserAccountCancelFormData () {
  return {
    type: RESET_USER_ACCOUNT_CANCEL_FORM_DATA,
  }
}

export function resetUserAccountManageSubscriptionData () {
  return {
    type: RESET_USER_ACCOUNT_MANAGE_SUBSCRIPTION_DATA,
  }
}

export function setUserAccountCancelSubscriptionConfirmProcessing (value) {
  return {
    type: SET_USER_ACCOUNT_CANCEL_CONFIRM_PROCESSING,
    payload: value,
  }
}

export function setUserAccountPauseProcessing (value) {
  return {
    type: SET_USER_ACCOUNT_PAUSE_PROCESSING,
    payload: value,
  }
}

export function setUserAccountPauseData (data, processing = false) {
  return {
    type: SET_USER_ACCOUNT_PAUSE_DATA,
    payload: { data, processing },
  }
}

export function setUserAccountCancelSubscriptionConfirmData (data, processing = false) {
  return {
    type: SET_USER_ACCOUNT_CANCEL_CONFIRM_DATA,
    payload: { data, processing },
  }
}

export function setUserAccountCancelConfirmAnswer (value) {
  return {
    type: SET_USER_ACCOUNT_CANCEL_CONFIRM_ANSWER,
    payload: value,
  }
}

export function setUserAccountDataBillingSubscriptions (data, processing = false) {
  return {
    type: SET_USER_ACCOUNT_DATA_BILLING_SUBSCRIPTIONS,
    payload: { data, processing },
  }
}

export function setUserAccountDataBillingSubscriptionsWithDetails (data, processing = false) {
  return {
    type: SET_USER_ACCOUNT_DATA_BILLING_SUBSCRIPTIONS_WITH_DETAILS,
    payload: { data, processing },
  }
}

export function setUserGiftSubscriptionsWithDetails (data, processing = false) {
  return {
    type: SET_USER_GIFT_SUBSCRIPTIONS_WITH_DETAILS,
    payload: { data, processing },
  }
}

export function setUserAccountBillingSubscriptionsProcessing (value) {
  return {
    type: SET_USER_ACCOUNT_BILLING_SUBSCRIPTIONS_PROCESSING,
    payload: value,
  }
}

export function setUserGiftSubscriptionsProcessing (value) {
  return {
    type: SET_USER_GIFT_SUBSCRIPTIONS_PROCESSING,
    payload: value,
  }
}

export function setUserAccountPauseLength (value) {
  return {
    type: SET_USER_ACCOUNT_PAUSE_LENGTH,
    payload: value,
  }
}

export function setUserAccountPauseFormData (data) {
  return {
    type: SET_USER_ACCOUNT_PAUSE_FORM_DATA,
    payload: data,
  }
}

export function changeUserAccountPlanTypeProcessing (value) {
  return {
    type: CHANGE_USER_ACCOUNT_CHANGE_PLAN_TYPE_PROCESSING,
    payload: value,
  }
}

export function changeUserAccountPlanTypeSetData (value) {
  return {
    type: CHANGE_USER_ACCOUNT_PLAN_TYPE_SET_DATA,
    payload: value,
  }
}

export function updateUserAccountPlan (value) {
  return {
    type: UPDATE_USER_ACCOUNT_PLAN,
    payload: value,
  }
}

export function clearUserAccountBillingSubscriptionsWithDetails () {
  return {
    type: CLEAR_USER_ACCOUNT_BILLING_SUBSCRIPTIONS_WITH_DETAILS,
  }
}

export function resetAccountChangePlanData () {
  return {
    type: RESET_ACCOUNT_CHANGE_PLAN_DATA,
  }
}

export function setUserAccountSubscriptionPaymentsProcessing (processing) {
  return {
    type: SET_USER_ACCOUNT_SUBSCRIPTION_PAYMENTS_PROCESSING,
    payload: processing,
  }
}

export function setUserAccountSubscriptionPaymentsData (data, processing = false) {
  return {
    type: SET_USER_ACCOUNT_SUBSCRIPTION_PAYMENTS_DATA,
    payload: { data, processing },
  }
}

export function setUserAccountInvoiceHistoryProcessing (processing) {
  return {
    type: SET_USER_ACCOUNT_INVOICE_HISTORY_PROCESSING,
    payload: processing,
  }
}

export function setUserAccountInvoiceHistoryData (data, processing = false) {
  return {
    type: SET_USER_ACCOUNT_INVOICE_HISTORY_DATA,
    payload: { data, processing },
  }
}

export function setUserAccountInvoiceProcessing (processing) {
  return {
    type: SET_USER_ACCOUNT_INVOICE_PROCESSING,
    payload: processing,
  }
}

export function setUserAccountInvoiceData (data, processing = false) {
  return {
    type: SET_USER_ACCOUNT_INVOICE_DATA,
    payload: { data, processing },
  }
}

export function setUserAccountCancelOfferShown (value) {
  return {
    type: UPDATE_USER_ACCOUNT_CANCEL_OFFER_SHOWN,
    payload: value,
  }
}

export function setUserAccountCancel () {
  return {
    type: SET_USER_ACCOUNT_CANCEL,
  }
}

export function updateUserAccountPause (duration) {
  return {
    type: UPDATE_USER_ACCOUNT_PAUSE,
    payload: duration,
  }
}

export function updateUserAccountResume () {
  return {
    type: UPDATE_USER_ACCOUNT_RESUME,
  }
}

export function setUserAccountType (value) {
  return {
    type: SET_USER_ACCOUNT_TYPE,
    payload: value,
  }
}
